module.exports = __webpack_public_path__ + "img/MAC1100_1-1.df628f94.jpg";